import { render } from "./AskDelayAdmin.vue?vue&type=template&id=0cf5784e&scoped=true"
import script from "./AskDelayAdmin.vue?vue&type=script&lang=js"
export * from "./AskDelayAdmin.vue?vue&type=script&lang=js"

import "./AskDelayAdmin.vue?vue&type=style&index=0&id=0cf5784e&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf5784e"]])

export default __exports__